/**
 * Czech texts of the workflow actions. The server sends the actions with
 * English `label` / `description`; the text itself is the key here (the
 * `workflow` namespace has no key or namespace separators). `{{env}}` is the
 * environment in the locative ("na produkci"), `{{envTo}}` in the genitive
 * ("do produkce").
 */
export const workflowActionsCs: Record<string, string> = {
  "Tests passed on {{env}}": "Testy prošly na {{env}}",
  "Internal testing on {{env}} passed — move to the next step.":
    "Interní testování na {{env}} prošlo — přejít na další krok.",
  "Client approved on {{env}}": "Klient schválil na {{env}}",
  "Client signed off the work on {{env}} — move to the next step.":
    "Klient práci na {{env}} odsouhlasil — přejít na další krok.",
  "Testing on {{env}} failed — send back to the developer for fixes.":
    "Testování na {{env}} neprošlo — vrátit vývojáři k opravě.",
  "Client rejected the work on {{env}} — send back to the developer for fixes.":
    "Klient práci na {{env}} odmítl — vrátit vývojáři k opravě.",
  "Return to developer": "Vrátit vývojáři",
  "Skip this test": "Přeskočit tento test",
  "Move on without testing on {{env}} (a trivial change). Requires a reason.":
    "Pokračovat bez testování na {{env}} (triviální změna). Vyžaduje důvod.",
  "Merged into {{env}}": "Sloučeno do {{envTo}}",
  "The maintainer merged the change into {{env}} — on to testing there.":
    "Maintainer změnu sloučil do {{envTo}} — následuje testování.",
  "Merge into {{env}} refused — send back to the developer for fixes.":
    "Sloučení do {{envTo}} zamítnuto — vrátit vývojáři k opravě.",
  "Start specification": "Zahájit specifikaci",
  "Manager drafts the technical specification before estimation.":
    "Manažer před odhadem připraví technickou specifikaci.",
  "Submit spec to client": "Předat specifikaci klientovi",
  "Send the specification to the client for approval.":
    "Poslat specifikaci klientovi ke schválení.",
  "Client approved spec": "Klient schválil specifikaci",
  "Client accepted the specification — proceed to estimation.":
    "Klient specifikaci přijal — pokračovat odhadem.",
  "Client requested changes": "Klient požaduje změny",
  "Client wants changes to the spec — back to drafting. Comment is recorded.":
    "Klient chce změny ve specifikaci — zpět k přípravě. Komentář se uloží.",
  "Assign to developer": "Přiřadit vývojáři",
  "Send to developer for estimation. Developer must be set in Team.":
    "Poslat vývojáři k odhadu. Vývojář musí být nastaven v týmu.",
  "Submit estimate": "Odeslat odhad",
  "Provide an hour estimate and submit for approval.":
    "Zadat odhad v hodinách a odeslat ke schválení.",
  Approve: "Schválit",
  "Accept the estimate and start development.": "Přijmout odhad a zahájit vývoj.",
  "Reject the estimate and send back for re-estimation.":
    "Odmítnout odhad a vrátit k novému odhadu.",
  "Back to backlog": "Zpět do backlogu",
  "Put the work off for now; the team stays on the ticket. Requires a reason.":
    "Práci prozatím odložit; tým na tiketu zůstává. Vyžaduje důvod.",
  "Re-estimate": "Odhadnout znovu",
  "The work turned out bigger than estimated; estimate it again.":
    "Práce se ukázala větší, než se odhadovalo; odhadnout znovu.",
  "Back to specification": "Zpět ke specifikaci",
  "The specification isn't enough to work from; rework it with the client.":
    "Ze specifikace nelze pracovat; přepracovat ji s klientem.",
  "Done — hand off to testing": "Hotovo — předat k testování",
  "Development finished — moves to the merge-into-dev gate (or straight to done when the project declares no testing at all).":
    "Vývoj dokončen — přesune se k bráně sloučení do dev (nebo rovnou do hotovo, pokud projekt žádné testování nedeklaruje).",
  "No change needed — hand off to testing": "Změna není potřeba — předat k testování",
  "Nothing needed changing — skips the merge-into-dev gate, since there's no MR to merge, straight to testing.":
    "Nebylo co měnit — přeskočí bránu sloučení do dev (není co slučovat) a jde rovnou k testování.",
  Cancel: "Zrušit",
  "Drop the work item before completion. Requires a reason.":
    "Zahodit tiket před dokončením. Vyžaduje důvod.",
  "Assign to user": "Přiřadit uživateli",
  "Pick who owns this task — moves it into in-progress and sets them as the assignee.":
    "Vybrat, kdo úkol vlastní — přesune ho do rozpracovaných a nastaví řešitele.",
  "Request client review": "Požádat klienta o kontrolu",
  "Hand off the task to the client for review before completing.":
    "Předat úkol klientovi ke kontrole před dokončením.",
  "Send the task back to the developer, optionally with a reason from the client review.":
    "Vrátit úkol vývojáři, volitelně s důvodem z kontroly klienta.",
  Complete: "Dokončit",
  "Client approved — close the task as done.": "Klient schválil — uzavřít úkol jako hotový.",
  "Done without review": "Hotovo bez kontroly",
  "The task needs no client sign-off; close it as done.":
    "Úkol nevyžaduje schválení klientem; uzavřít jako hotový.",
  "Drop the task before completion. Requires a reason.":
    "Zahodit úkol před dokončením. Vyžaduje důvod.",
  "Start fix": "Zahájit opravu",
  "Confirm the hotfix is real and start working on the fix.":
    "Potvrdit, že hotfix je skutečný, a začít na opravě pracovat.",
  "Resolved — ready to merge": "Vyřešeno — připraveno ke sloučení",
  "The fix is done and verified — hand off to the maintainer to merge into {{env}}.":
    "Oprava je hotová a ověřená — předat maintainerovi ke sloučení do {{envTo}}.",
  "Back to triage": "Zpět do třídění",
  "Not actionable right now — return the hotfix to triage.":
    "Teď se nedá řešit — vrátit hotfix do třídění.",
  "Drop the hotfix before resolution. Requires a reason.":
    "Zahodit hotfix před vyřešením. Vyžaduje důvod.",
  "Waiting on client": "Čeká se na klienta",
  "Park the ticket until the client answers. Say what you're waiting for.":
    "Odložit tiket, dokud klient neodpoví. Napište, na co se čeká.",
  "Client replied": "Klient odpověděl",
  "The client answered; the ticket goes back to where it was.":
    "Klient odpověděl; tiket se vrací tam, kde byl.",
  "Start anyway": "Zahájit i tak",
  "Hub resumes the ticket by itself once its last blocker closes; this starts it now.":
    "Hub tiket obnoví sám, jakmile se zavře poslední blokující tiket; tímto ho zahájíte hned.",
  "Back to waiting for blocker": "Zpět do čekání na závislost",
  "The ticket still has an open blocking ticket; park it until Hub resumes it when the last one closes.":
    "Tiket má stále otevřený blokující tiket; odložit ho, dokud ho Hub nevrátí po zavření posledního z nich.",
  Reopen: "Znovu otevřít",
  "Something broke again after delivery. Requires a reason.":
    "Po dodání se něco znovu pokazilo. Vyžaduje důvod.",
  Restore: "Obnovit",
  "Bring a cancelled ticket back to its first state.": "Vrátit zrušený tiket do prvního stavu.",
  "Close as resolved": "Uzavřít jako vyřešené",
  "Solved elsewhere, no change of its own needed. Requires a reason.":
    "Vyřešeno jinde, vlastní změna není potřeba. Vyžaduje důvod.",
  Block: "Zablokovat",
  Unblock: "Odblokovat",
};

/** Environment names in the locative / genitive, for the Czech texts. */
export const workflowEnvCs: Record<string, { at: string; to: string }> = {
  dev: { at: "dev", to: "dev" },
  test: { at: "testu", to: "testu" },
  production: { at: "produkci", to: "produkce" },
};
